import { createSelector } from 'reselect'
import getItemsCartSelect from 'modules/cart/redux/selectors/get-items'
import isFullSizeDiscountVariantUtil from 'modules/variant/utils/is-full-size-discount'

const getRealItemsCartSelect = createSelector(
  getItemsCartSelect,
  (items) => items.filter(item => !isFullSizeDiscountVariantUtil(item))
)

export default getRealItemsCartSelect
